import {common} from '@priority-software/priority-proto-api/lib';
import {getLang} from '../../../../../../../Localization';
import {
    getServerStoreData,
    setServerStoreData
} from '../../../../../../../services/proto/ServerStorage/service';
import {getCompanyName} from '../../../../../../../utils/proto-api-utils/utils';
import {SavedSearch} from '../../../../../types';

export interface savedSearchToServer extends Omit<SavedSearch, 'isDefault'> {
    isDefault: number;
}

export const getSavedSearches = async (formName: string) => {
    const key = `SAVED_SEARCH_${formName}_${getCompanyName()}_${getLang()}`;
    const res = await getServerStoreData([key], true, true);

    return res[key] ? JSON.parse(res[key].Str) : null;
};

export const updateSavedSearches = async (searches: savedSearchToServer[], formName: string) => {
    const key = `SAVED_SEARCH_${formName}_${getCompanyName()}_${getLang()}`;

    const searchesToSave = new common.Constant({Str: JSON.stringify(searches)});
    const searchesStr = {[key]: searchesToSave};
    setServerStoreData(searchesStr, true, true);
};

//need investigate can we use key creator "getStorageKey"

export const getResentSearches = async (formName: string) => {
    const key = `RECENT_SEARCH_${formName}_${getCompanyName()}_${getLang()}`;
    const res = await getServerStoreData([key], true, true);

    return res[key] ? JSON.parse(res[key].Str) : null;
};
export const updateRecentSearches = async (searches: savedSearchToServer[], formName: string) => {
    const key = `RECENT_SEARCH_${formName}_${getCompanyName()}_${getLang()}`;

    const searchesToSave = new common.Constant({Str: JSON.stringify(searches)});
    const searchesStr = {[key]: searchesToSave};
    setServerStoreData(searchesStr, true, true);
};
